import { Column } from "react-data-grid";
import { CPAttachment } from "../../../api/models/unified";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import { renderDate } from "../../../helpers/dayjsHeleprs";
import Table from "../../table/Table";
import { useMemo } from "react";
import { downloadURI } from "../../../helpers/fileHelper";
import { MAIN_IMAGE_ROOT } from "../../../app_config";
import Icon from "../../icon/Icon";
import { isImage } from "../../../helpers/attachmentsHelepr";

interface AttachmentsGalleryTableViewProps {
  attachments: CPAttachment[];
  handleOpenPreview: (attachment: CPAttachment) => void;
}

interface AttachmentTableActionsProps {
  attachment: CPAttachment;
  handleOpenPreview: (attachment: CPAttachment) => void;
}

const AttachmentTableActions = ({
  attachment,
  handleOpenPreview,
}: AttachmentTableActionsProps) => {
  const localIsImage = useMemo(() => isImage(attachment), [attachment]);

  return (
    <div className="flex flex-row items-center gap-4">
      <Icon
        name="eye"
        className="cursor-pointer"
        onClick={() =>
          localIsImage
            ? handleOpenPreview(attachment)
            : window.open(`${MAIN_IMAGE_ROOT}${attachment.publicUrl}`, "_blank")
        }
      />
      <Icon
        name="file-download"
        className="cursor-pointer"
        onClick={() =>
          downloadURI(
            `${MAIN_IMAGE_ROOT}${attachment.publicUrl}`,
            attachment.name,
          )
        }
      />
    </div>
  );
};

const AttachmentsGalleryTableView = ({
  attachments,
  handleOpenPreview,
}: AttachmentsGalleryTableViewProps) => {
  const { t } = useCustomTranslation();

  const columns = useMemo(
    (): Column<CPAttachment>[] => [
      { key: "name", name: t("attachment_name") },
      {
        key: "created",
        name: t("attachment_created"),
        renderCell: ({ row }) => renderDate(row.created),
      },
    ],
    [t],
  );

  return (
    <Table
      columns={columns}
      data={attachments}
      renderItemActions={(item) => (
        <AttachmentTableActions
          attachment={item}
          handleOpenPreview={handleOpenPreview}
        />
      )}
      detailMode
    />
  );
};

export default AttachmentsGalleryTableView;
